import(/* webpackMode: "eager" */ "/home/ubuntu/download/69898d48f782d50014eafb95/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69898d48f782d50014eafb95/website_project/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69898d48f782d50014eafb95/website_project/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69898d48f782d50014eafb95/website_project/src/components/ui/AppImage.tsx");
